import axios from 'axios';
import { setLogin } from '../authReducer/adminReducer.js';
import { setAltCodpmpol, setClientContainPlan, setCodPme, setCodpmpol, setErrorEncrypt, setHomeData, setIiipol, setIntpol, setLoading, setResetData, setStateError, setStatePlanDetail } from './stepReducer.js';
import { strToDate } from '../../../utilities/index.js';
import dayjs from 'dayjs';


// export let url = import.meta.env.REACT_APP_CUSTOM_URL;
export let url = process.env.REACT_APP_CUSTOM_URL;
export const options = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };
export const params = new URLSearchParams();
let dir = window.location.href;

let test = dir.includes('/?!!'); /*true*/;
if (test) {
    dir = dir.replace('/?!!', '/?');
    url = process.env.REACT_APP_CUSTOM_TEST_URL;
    // url = import.meta.env.VITE_APP_CUSTOM_TEST_URL;
};

if (dir.split('#')[0] !== process.env.REACT_APP_ENV_DEV) {
    console.error = function () { };
    console.log = function () { };
};

// if (dir !== import.meta.env.VITE_APP_LOCAL_TEST) {
//     console.error = function () { };
//     console.log = function () { };
// };

// if (dir === import.meta.env.VITE_APP_LOCAL_TEST) {
//     url = import.meta.env.VITE_APP_CUSTOM_TEST_URL;
//     test = true;
//     dir = 'https://www.platform.com.ar/web/#/?kLy4jqqudloO5L6Oj7cxv9rD0vX+6r0P1qqWSLRumlsY2OyZbNVipZs+X7TfD7VP7BS/+MwFCOMt53ALEWxlmBIRRth7FmQmmS7btnp3AiJpvhdf8iRhi2YLz/fN4rV9JgwBOL5vAPY2fDkEK9rzWaD/z2st2LTF530GDynHFi4='
// };


export function createErrorEmail(message) {
    return async function (dispatch) {
        params.set('opcpm', "ezeEmail");
        params.set('mensaje', message);
        await axios.post(url, params, options)
            .then((r) => {
                // console.log(r)
            })
            .catch(() => {
                // window.alert('Hubo un problema al crear el email');
            });
    };
};


export function logIn(data) {
    // if (localStorage.getItem('url') && localStorage.getItem('test')) {
    //     //     const url_currently = JSON.parse(localStorage.getItem('url'));
    //     //     if (dir.length === 207) {
    //     //         if (dir !== url_currently) {
    //     //             console.log('Son distintos');
    //     //             localStorage.setItem('url', JSON.stringify(dir));
    //     //             localStorage.setItem('test', JSON.stringify(test));
    //     //         }
    //     //     } else {
    //     //         console.log('Se refrescó la web. Iguales');
    //     test = JSON.parse(localStorage.getItem('test'));
    //     dir = JSON.parse(localStorage.getItem('url'));
    //     //     }
    // } else {
    //     localStorage.setItem('url', JSON.stringify(dir));
    //     localStorage.setItem('test', JSON.stringify(test));
    // };
    console.log('Application development environment');
    return async (dispatch, _) => {
        params.set('test', test);
        params.set('params', dir);
        params.set("opcpm", "");
        await axios.post(url, params, options)
            .then(r => {
                console.log('r.data:', r.data);
                if (!r.data.error) {
                    let codProvincia;
                    const products = [];
                    const provinces = [];
                    const cities = [];
                    const menu = [];
                    const countries = [];
                    const brand = [];
                    const activities = [];
                    const vendors = [];
                    const sucursales = [];
                    const regions = [];
                    const zones = [];
                    const optState = [];
                    const sections = [];
                    const sinistersSections = [];
                    const companias = [];
                    const causes = [];
                    const coverages = [];
                    const sinistersStates = [];
                    const relationship = [];
                    const optTypeUser = [];
                    const ciaPol = [];
                    const empresas = [];
                    const cards = [];
                    let response;
                    let existsToken;
                    const dataPayment = {
                        arrPayMethod: [],
                        payMethodMoto: [],
                        rel: [],
                    };

                    r.data.provincias?.forEach(item => {
                        provinces.push({ value: item.codprv, label: item.nomprv });
                    });

                    r.data.menu?.forEach(item => {
                        products.push({
                            plan: item.nompro,
                            label: item.nompro,
                            plapro: item.plapro,
                            price: item.impcot.toFixed(2),
                            details: item.despro.includes("\n") ? item.despro.split("\n") : item.despro.split("!"),
                            section: parseInt(item.codsec),
                            codpro: item.codpro,
                            value: item.codpro,
                        });
                        menu.push({
                            codsec: parseInt(item.codsec),
                            nomsec: item.nomsec,
                            codcia: item.codcia,
                            fecpro: item.fecpro
                        });
                    });

                    products?.sort((a, b) => a.price - b.price);
                    /* 
                        El ordenamiento funciona para que deje los precios 0 al principio
                        así, el componente Table usará el índice para mostrar los precios
                        de las motos con la columna correspondiente
                    */

                    r.data.paises?.forEach((item) => {
                        countries.push({
                            value: item.codpai,
                            label: item.nompai,
                        });
                    });

                    r.data.marcas?.forEach((item) => {
                        brand.push({
                            value: item.codmar,
                            label: item.desmar,
                        });
                    });

                    r.data.formasdepago?.forEach((item) => {
                        dataPayment.arrPayMethod.push({
                            value: item.codpag,
                            label: item.nompag,
                            codpro: item.codpro,
                            id: item.idpag,
                            codsec: item.codsec,
                        });
                    });

                    r.data.actividades?.forEach((item) => {
                        activities.push({
                            value: item.codact,
                            label: item.nomact,
                        });
                    });

                    r.data.usuarios?.forEach((vendedor) => {
                        let suc = r.data.sucursales?.find(suc => suc.codsuc === vendedor['cod-suc']);
                        let reg = r.data.regiones?.find(reg => reg.codreg === Number(suc?.codreg));
                        vendedor['ape-usu'] && vendors.push({
                            ...vendedor,
                            value: vendedor['ven-usu'],
                            label: vendedor['ape-usu'],
                            sucursal: vendedor['cod-suc']?.toString(),
                            region: reg?.codreg?.toString(),
                            zona: reg?.codzon?.toString(),
                            'cod-suc': vendedor['cod-suc']?.toString(),
                        });
                    });

                    r.data.sucursales?.forEach((sucursal) => {
                        sucursales.push({ value: sucursal.codsuc.toString(), label: sucursal.nomsuc, codreg: sucursal.codreg });
                    });

                    r.data.regiones?.forEach((region) => {
                        regions.push({ value: region.codreg.toString(), label: region.nomreg, codzon: region.codzon });
                    });

                    r.data.zonas?.forEach((zona) => {
                        zones.push({ value: zona.codzon.toString(), label: zona.nomzon });
                    });

                    r.data.estados?.forEach((estado) => {
                        optState.push({ value: estado.codpme, label: estado.despme });
                    })

                    r.data.secciones?.forEach(seccion => {
                        if (seccion.sinsec)
                            sinistersSections.push({ value: seccion.codsec, label: seccion.nomsec });
                        if (seccion.consec)
                            sections.push({ value: seccion.codsec, label: seccion.nomsec });
                    });

                    r.data.companias?.forEach(compania => {
                        companias.push({ value: compania.codcia, label: compania.nomcia, tel: compania.telcia });
                    });

                    r.data.coberturas?.forEach(cobertura => {
                        coverages.push({ value: cobertura.codcob, label: cobertura.descob });
                    });

                    r.data.causas?.forEach(causa => {
                        causes.push({ value: causa.codcau, label: causa.descau });
                    });

                    r.data.estadosSiniestros?.forEach(estado => {
                        sinistersStates.push({ value: estado.codpes, label: estado.despes });
                    });

                    r.data.parentescos?.forEach(parentesco => {
                        relationship.push({ value: parentesco.codpmp, label: parentesco.despmp });
                    });

                    r.data.niveles?.forEach(nivel => {
                        nivel.codpca < 10 && optTypeUser.push({ value: nivel.codpca, label: nivel.despca });
                    })

                    r.data.ciaPol?.forEach(pol => {
                        ciaPol.push({ ...pol, value: pol['pol-pcp'], label: pol['pol-pcp'] });
                    })

                    r.data.empresas?.forEach(emp => {
                        empresas.push({ value: emp['cod-emp'], label: emp['nom-emp'] });
                    })

                    r.data.tarjetas?.forEach(tarjeta => {
                        cards.push({ ...tarjeta, 'cod-sec': Number(tarjeta['cod-sec']), value: tarjeta['cod-tar'], label: tarjeta['nom-tar'] });
                    })

                    if (r.data.respuesta) {
                        response = r.data.respuesta;
                        localStorage.setItem("response", JSON.stringify(r.data.respuesta));
                    };
                    if (r.data.existeToken) {
                        existsToken = r.data.existeToken;
                    };

                    const payload = {
                        provinces,
                        cities,
                        countries,
                        menu,
                        products,
                        brand,
                        codProvincia,
                        activities,
                        vendors,
                        sucursales,
                        regions,
                        zones,
                        optState,
                        companias,
                        sections,
                        coverages,
                        causes,
                        sinistersStates,
                        sinistersSections,
                        relationship,
                        optTypeUser,
                        ciaPol,
                        cards,
                        empresas,
                        arrPayMethod: dataPayment?.arrPayMethod,
                        payMethodMoto: dataPayment?.payMethodMoto,
                        nameCompany: r.data?.empresa?.abremp,
                        codemp: r.data.empresa?.codemp,
                        infoCompany: r.data?.empresa,
                        response,
                        existsToken,
                        error: false,
                        user: {
                            // nro de intención de venta de M!
                            nro: data?.nro,
                            email: r.data?.nomusu,
                            legajo: r.data?.legajo,
                            sucursal: r.data?.nomsuc,
                            vendor: r.data?.venusu,
                            password: data?.password,
                            name: r.data?.nombre,
                            address: r.data?.direccion,
                            sex: r.data?.sexo,
                            login: r.data?.venusu ? true : false,
                            id: r.data?.codusu,
                            isAdmin: r.data?.codpca === 10,
                            level: Number(r.data?.codpca),
                            opcusu: r.data?.opcusu,
                            test: data?.test || r.data.test,
                        },
                    };
                    dispatch(setLogin({ ...payload, logged: true }));
                }
                else {
                    const payload = {
                        logeado: false,
                        error: true,
                        msgError: r.data.error || 'Error',
                    }
                    dispatch(setLogin({ payload }));
                }
            })
            .catch((error) => {
                dispatch(setLogin({ error: '505' }));
                let message = `Error 505! Hubo un error al iniciar sesion ${error}`
                dispatch(createErrorEmail(message));
                // window.location.replace('https://test-seguros.emusimundo.com:9002/webapi/platformWeb/cotizar/2ggGvy');
            });
    };

};

export function searchCities(provinceCode, codcia, nomlcia) {
    // console.log(provinceCode, codcia)
    return async function (dispatch) {
        params.set('opcpm', "localidades");
        params.set('codcia', codcia);
        params.set('codprv', provinceCode);
        await axios.post(url, params, options)
            .then(r => {
                console.log(r.data)
                const cities = [];
                r.data.forEach(item => {
                    const exist = cities.find(p => p.label.startsWith(item.nomloc));
                    if (!exist)
                        cities.push({
                            codprv: item.codprv,
                            value: item.codloc,
                            label: item.nomloc,
                        })
                });
                dispatch(setLogin({ cities, nomlcia: '' }));
            })
            .catch(() => {
                dispatch(setLogin({ cities: [], nomlcia: '' }));
                let message = "Hubo un error al buscar las provincias";
                dispatch(createErrorEmail(message));
            });
    };
};



export function saveMenu(data, company, recid) {
    console.log(data, company)
    return async function (dispatch) {
        params.set('opcpm', "Menu");
        params.set('test', test);
        params.set('webpol', 'yes');
        params.set('ninpol', data.nro || 0);
        params.set('codemp', company);
        params.set('codsec', data.codsec);
        params.set('dnipol', data.dni || '');
        params.set('venusu', data.origen);
        params.set('codcia', data.codcia);
        params.set('codpmpol', recid || '');
        dispatch(setLoading(true));
        await axios.post(`${url}?opcpm=Menu&test=${test}&webpol=yes&ninpol=${data.nro || 0}&codemp=${company}&codsec=${data.codsec}&dnipol=${data.dni || ''}&venusu=${data.origen || 'WebM'}&codcia=${data.codcia}&params=${dir}`)
            // await axios.post(url, params, options)
            .then(r => {
                console.log('respuesta: ', r.data);
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    localStorage.setItem('codpmpol', JSON.stringify(r.data.codpmpol));
                } else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                    const storageFirstStep = JSON.parse(localStorage.getItem('firstStep'));
                    let message = `Error 505 en src/redux/stepReducer/thunks.js/saveMenu | Intencion: ${storageFirstStep?.nro} | Seccion ${storageFirstStep?.codsec}`;
                    dispatch(createErrorEmail(message));
                    dispatch(setErrorEncrypt(true));
                }
                dispatch(setLoading(false));
            })
            .catch((error) => {
                dispatch(setCodpmpol(''));
                dispatch(setLoading(false));
                dispatch(setErrorEncrypt(true));
                let message = `505! Hubo un error en saveMenu ${error}`;
                dispatch(createErrorEmail(message));
            });
    }
};

export function saveMenuTwo(data, company, recid) {
    // console.log(data, company, recid)
    const nroInt = Math.round(data.nro);
    return async function (dispatch) {
        params.set('opcpm', "Menu");
        params.set('webpol', 'yes');
        params.set('codpmpol', recid || '');
        params.set('ninpol', nroInt || 0);
        params.set('codemp', company);
        params.set('codsec', data.codsec);
        params.set('dnipol', data.dni || '');
        params.set('venusu', data.origen || 'WebM');
        params.set('codcia', data.codcia);
        await axios.post(`${url}?opcpm=Menu&test=${test}&webpol=yes&codpmpol=${recid}&ninpol=${nroInt || 0}&codemp=${company}&codsec=${data.codsec}&dnipol=${data.dni || ''}&venusu=${data.origen || 'WebM'}&codcia=${data.codcia}&params=${dir}&test=${test}`)
            // await axios.post(url, params, options)
            .then(r => {
                console.log('respuesta: ', r.data);
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                    if (r.data.error.descripcion) {
                        dispatch(setStateError(r.data.error.descripcion));
                        if (data.codsec === '8') {
                            dispatch(setStatePlanDetail(r.data.error.detalle || []));
                        };
                        dispatch(setClientContainPlan(true));
                    } else {
                        dispatch(setClientContainPlan(false));
                        dispatch(setStateError(''));
                    };
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
            })
            .catch((error) => {
                dispatch(setCodpmpol(''));
                dispatch(setLoading(false));
                let message = `505! Hubo un error en saveMenuTwo ${error}`;
                dispatch(createErrorEmail(message));
            });
    }
};

export function saveTitularData(data, recid) {
    // let found = 0;
    // for (const prop in data) {
    //     if (data[prop] === '' && prop !== "product" || data[prop] === undefined) {
    //         found++;
    //     };
    // };
    // if (found > 0) {
    //     let message = `505! Hubo un error al guardar los datos del titular ${data, recid}`;
    //     // dispatch(createErrorEmail(message))
    //     return;
    // }
    return async function (dispatch) {
        // console.log(data.birthday)
        let date;
        if (data.birthday) {
            date = dayjs(data.birthday).format('DD/MM/YYYY');
        };
        params.set('opcpm', "TitularData");
        params.set('codpmpol', recid);
        params.set('webpol', 'yes');
        params.set('codsec', data.codsec);
        params.set('venusu', data.origen);
        params.set('codcia', data.codcia);
        params.set('codact', data.activity);
        params.set('dompol', data.address);
        params.set('arepol', data.area);
        params.set('codloc', data.city);
        params.set('codpro', data.codpro);
        params.set('dnipol', data.dni);
        params.set('emapol', data.email);
        params.set('exppol', data.expose);
        params.set('sexpol', data.genre);
        params.set('apepol', data.lastname);
        params.set('nompol', data.name);
        params.set('codpai', data.nationality);
        params.set('telpol', data.phone);
        // params.set('plapol', data.plan);
        params.set('plapol', data.plapro);
        params.set('anopol', data.year);
        params.set('nacpol', date ? strToDate(date) : '');
        params.set('numpol', data.numAddress || '');
        // params.set('codsec', data.codsec);
        // params.set('ecapol', data.between);
        // params.set('telpol', data.celular || data.phone); 
        // params.set('cuipol', data.cuil);
        await axios.post(url, params, options)
            .then(r => {
                console.log('respuesta: ', r.data)
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
                // dispatch(setCodpmpol(''));
                // localStorage.removeItem('codpmpol');
            })
            .catch((error) => {
                dispatch(setCodpmpol(''));
                let message = `505! Hubo un error al guardar los datos del titular ${error}`;
                dispatch(createErrorEmail(message));
            });
    };
};

export function saveHomeData(data, recid) {
    // console.log(data, recid)
    let found = 0;
    for (const prop in data) {
        if (data[prop] === '' && prop !== "registeredAddress" || data[prop] === undefined) {
            found++;
        };
    };
    if (found > 0) {
        let message = `505! Hubo un error al guardar los datos de hogar ${data, recid}`;
        // dispatch(createErrorEmail(message));
        return;
    };
    return async function (dispatch) {
        params.set('opcpm', "HomeData");
        params.set('codpmpol', recid);
        params.set('webpol', 'yes');
        params.set('idomloc', data.address);
        params.set('codviv', data.homeType);
        params.set('icodloc', data.city);
        params.set('mtspol', data.squareMeters);
        await axios.post(url, params, options)
            .then(r => {
                // console.log('respuesta: ', r.data)
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
                if (r.data.error.descripcion !== '') {
                    dispatch(setHomeData({ registeredAddress: r.data.error.descripcion }));
                } else dispatch(setHomeData({ registeredAddress: '' }));
            })
            .catch(r => {
                dispatch(setCodpmpol(''));
                let message = `505! Hubo un error al guardar los datos de hogar ${error}`;
                dispatch(createErrorEmail(message));
            });
    };
};

export function saveBeneficiary(legal, data, recid, lastBen) {
    // console.log(legal, data, recid, lastBen)
    return async function (dispatch) {
        params.set('opcpm', "BeneficiaryData");
        params.set('codpmpol', recid);
        params.set('webpol', 'yes');
        params.set('blepol', legal);
        data && params.set('pmben', JSON.stringify(data));
        params.set('lastBen', lastBen);
        await axios.post(url, params, options)
            .then(r => {
                // console.log('respuesta: ', r.data)
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
            })
            .catch(r => {
                dispatch(setCodpmpol(''));
                let message = `505! Hubo un error al guardar los datos de beneficiarios ${error}`;
                dispatch(createErrorEmail(message));
            });
    }
};

export function savePayMethod(data, recid) {
    let found = 0;
    for (const prop in data) {
        if ((!data[prop] /*=== '' || data[prop] === undefined*/) && prop !== "creditCard") {
            found++;
        };
    };
    if (found > 0) {
        let message = `505! Hubo un error al guardar los datos del pago ${data, recid}`;
        // dispatch(createErrorEmail(message));
        return;
    }
    else return async function (dispatch) {
        params.set('opcpm', "PayMethod");
        params.set('codpmpol', recid);
        params.set('codpag', "1");
        params.set('webpol', 'yes');
        // params.set('codtar', data.cardNumber[0] == '4' ? 'VISA' : data.cardNumber[0] == '5' ? 'MASTER' : data.cardNumber[0] == '3' ? 'AMEX' : '');
        params.set('codtar', data.creditCard);
        params.set('tnumpol', data.cardNumber.replaceAll(" ", ""));
        params.set('tnompol', data.fullName);
        params.set('tdnipol', data.dni);
        params.set('tvtopol', data.expires);
        params.set('prepol', data.price);
        params.set('ul4pol', data.cardNumber.replaceAll(" ", "").slice(-4));
        params.set('tarnumpgp', data.encryptedNumber);
        await axios.post(url, params, options)
            .then(r => {
                console.log('respuesta: ', r.data)
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    dispatch(setAltCodpmpol(r.data.codpmpol));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
            })
            .catch(r => {
                dispatch(setCodpmpol(''));
                let message = `505! Hubo un error al guardar los datos del pago ${error}`;
                dispatch(createErrorEmail(message));
            });
    };
};

export function saveTecnologyData(data, recid) {
    const date = dayjs(data.birthdate).format('DD/MM/YYYY');
    return function (dispatch) {
        params.set('opcpm', "TecnologyData");
        params.set('codpmpol', recid);
        params.set('naspol', data.name);
        params.set('aaspol', data.lastname);
        params.set('faspol', strToDate(date));
        // params.set('faspol', data.birthdate);
        params.set('daspol', data.dni);
        params.set('modpol', data.model);
        params.set('marpol', data.brand);
        axios.post(url, params, options)
            .then(r => {
                // console.log('respuesta: ', r.data)
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
            })
            .catch(r => {
                dispatch(setCodpmpol(''));
                let message = `505! Hubo un error al guardar los datos de tecnología portatil ${error} | Informacion: ${data} | Recid: ${recid}`;
                dispatch(createErrorEmail(message));
            });
    };
};



export function finishPurchase(user, recid) {

    return async function (dispatch) {
        params.set('opcpm', "VerConfirmar");
        params.set('codpmpol', recid);
        await axios.post(url, params, options)
            .then(r => {
                console.log('respuesta: ', r.data)
                if (r.data.codpmpol) {
                    dispatch(setCodpmpol(r.data.codpmpol));
                    dispatch(setIiipol(r.data.iiipol));
                    dispatch(setIntpol(r.data.intpol));
                    dispatch(setCodPme(r.data.codpme));
                    localStorage.setItem("codpmpol", JSON.stringify(r.data.codpmpol));
                }
                else {
                    dispatch(setCodpmpol(''));
                    localStorage.removeItem('codpmpol')
                };
            })
            .catch(r => {
                dispatch(setCodpmpol(''));
                let message = `505! Hubo un error al finalizar compra ${error}`;
                dispatch(createErrorEmail(message));
            });
    };
};


export function cancelPurchase(codpmpol) {
    // console.log(codpmpol);
    const rejectUrl = process.env.REACT_APP_ACEPPT_PM;
    return async function (dispatch) {
        params.set('opcpm', 'Reject');
        params.set('codpmpol', codpmpol);
        axios.post(rejectUrl, params, options)
            .then((r) => {
                // console.log(r);
            })
            .catch(r => {
                // console.log(r);
            });
    }
};

